import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=37eda2ac&scoped=true"
import script from "./bind.vue?vue&type=script&lang=js"
export * from "./bind.vue?vue&type=script&lang=js"
import style0 from "./bind.vue?vue&type=style&index=0&id=37eda2ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eda2ac",
  null
  
)

export default component.exports